<template>
  <div class="container">
    <h1 class="left">邦睿科技</h1>
    <div class="right">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        :router="true"
      >
        <el-menu-item index="home">首页</el-menu-item>
        <el-submenu index="2">
          <template slot="title">解决方案</template>
          <el-menu-item index="intelligentAudit">智能审计</el-menu-item>
          <el-menu-item index="intelligentControl">智能风控</el-menu-item>
          <el-menu-item index="riskControl">银行交易反欺诈</el-menu-item>
        </el-submenu>
        <!-- <el-menu-item index="ito">通用技术服务</el-menu-item> -->
        <el-menu-item index="partner">合作伙伴</el-menu-item>
        <el-menu-item index="about">关于我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "br-header",
  components: {},
  data() {
    return {
      activeIndex: "home",
    };
  },
  computed: {},
  watch: {},
  created() {
    this.activeIndex = this.$route.path.slice(1);
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  position: fixed;
  z-index: 10;
  box-sizing: border-box;
  width: 100vw;
  height: 70px;
  background-color: #00589b;
  padding: 0 120px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    width: 200px;
    height: 40px;
    background: url("~@/assets/logo.png");
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 0px;
  }
  .right {
    .el-menu {
      border: none;
    }
    .el-menu-demo {
      background-color: transparent;
    }
    .el-menu-item {
      color: #ffffff;
      font-size: 16px;
      line-height: 67px;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      outline: 0;
      background-color: transparent;
      color: #fff;
      font-size: 16px;
    }
    .el-menu--horizontal /deep/ .el-submenu .el-submenu__title {
      color: #fff;
      font-size: 16px;
      line-height: 67px;
    }
    .el-menu--horizontal /deep/ .el-submenu :hover {
      background-color: transparent;
    }
    .el-menu--horizontal /deep/ .el-submenu .el-submenu__title :hover {
      color: transparent;
    }
    .el-menu--horizontal /deep/ .el-menu-item.is-active {
      border-bottom: 2px solid #409eff;
      height: 67px;
      line-height: 67px;
    }
    .el-menu--horizontal /deep/.el-submenu.is-active .el-submenu__title {
      border-bottom: 2px solid #409eff;
      height: 67px;
      line-height: 67px;
    }
  }
}
</style>
